export default "__VITE_ASSET__J15ewgCF__"